import './BreadCrumbs.css';

import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { BreadCrumbCrumb } from '../../../types/types';

interface BreadCrumbsProps {
  breadcrumbs: BreadCrumbCrumb[];
}

const BreadCrumbs = forwardRef<HTMLDivElement, BreadCrumbsProps>(
  ({ breadcrumbs }, ref) => {
    if (breadcrumbs.length === 1) return <div ref={ref} />;

    return (
      <div ref={ref} className="breadcrumbs-container">
        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;

          if (isLast) {
            return (
              <span
                key={breadcrumb.tokenId}
                className={clsx('breadcrumb-item', 'breadcrumb-item-last')}
              >
                {breadcrumb.name}
              </span>
            );
          }

          return (
            <div key={breadcrumb.tokenId} className="breadcrumb-item">
              <Link replace to={breadcrumb.url}>
                {breadcrumb.name}
              </Link>
              <span>{'>'}</span>
            </div>
          );
        })}
      </div>
    );
  }
);

export default BreadCrumbs;
